window.waveCustomerForm2 = window.waveCustomerForm2 || {};

window.waveCustomerForm2.constants = {
  divIDCustomerForm2: 'divCustomerForm2',
  divIDBackground: 'divCustomerForm2Background',
  divIDPopup: 'divCustomerForm2Popup',
  // divIDIframe: 'divCustomerFormIframe',
  divIDMain: 'divCustomerForm2Main',
  divIDLoading: 'divCustomerForm2Loading',
  
  urlCustomerForm2: 'https://account-registration-customer-form2-dev.wavecommerce.hk/',
};

window.waveCustomerForm2.openPopup = ({ customerForm2Id }) => {
  const app = window.waveCustomerForm2;
  const CONSTANTS = app.constants;
  const utils = app.utils;

  const landingUrl = window.location.href;

  const htmlRoot = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
  htmlRoot.classList.add('html--popup-active');
  
  app.CustomerForm2 = document.createElement('div');
  app.CustomerForm2.setAttribute('id', CONSTANTS.divIDCustomerForm2);

  const popup = document.createElement('div')
  popup.setAttribute('id', CONSTANTS.divIDPopup)
  
  const background = document.createElement('div')
  background.setAttribute('id', CONSTANTS.divIDBackground)
  background.innerHTML = ' '
  background.addEventListener('click', window.waveCustomerForm2.closePopup)

  const main = document.createElement('div');
  main.setAttribute('id', CONSTANTS.divIDMain);
  main.innerHTML = `
    <customer-form2-element
      shop="${window.Shopify.shop}"
      root="${window.Shopify.shop + window.Shopify.routes.root.replace(/\/$/, '')}"
      landing-url="${landingUrl}"
      customer-form2-id="${customerForm2Id}"
      locale="${window.Shopify.locale}"
    ></customer-form2-element>
  `

  const closeButtonRow = document.createElement('div')
  closeButtonRow.classList.add('popup-close-button-row')

  const closeButton = document.createElement('div')
  closeButton.classList.add('popup-close-button')

  closeButton.innerHTML = '&times;'
  closeButton.addEventListener('click', window.waveCustomerForm2.closePopup)

  closeButtonRow.appendChild(closeButton)

  popup.appendChild(closeButton)
  // popup.appendChild(iframe)
  popup.appendChild(main)

  app.CustomerForm2.appendChild(background);
  app.CustomerForm2.appendChild(popup);
  
  document.body.appendChild(app.CustomerForm2);
};

window.waveCustomerForm2.closePopup = () => {
  // remove css class to allow scrolling
  const htmlRoot = document.getElementsByTagName( 'html' )[0]; // '0' to assign the first (and only `HTML` tag)
  htmlRoot.classList.remove('html--popup-active');
  
  const app = window.waveCustomerForm2;
  app.CustomerForm2.remove();
}

document.addEventListener('waveCustomerForm2:closePopup', window.waveCustomerForm2.closePopup);
